import i18n from "../../../../localization/i18n.js";
import tokens from "../../../../localization/tokens.js";

/**
 * Checks if the total shares allocated to beneficiaries match the required percentage.
 * @param {boolean} checkContingent - Flag to determine if contingent beneficiaries need to be checked.
 * @param {array} primaryBeneficiaries - Array of primary beneficiaries.
 * @param {array} contingentBeneficiaries - Array of contingent beneficiaries.
 * @param {number} shares - Total shares to be validated.
 * @param {string} beneficiaryID - ID of the beneficiary being modified.
 * @param {boolean} isDeleteBeneficiary - Flag indicating if a beneficiary is being deleted.
 * @returns {boolean} - True if the total shares match the required percentage, false otherwise.
 */
const checkShares = (checkContingent = false, primaryBeneficiaries, contingentBeneficiaries, shares, beneficiaryID, isDeleteBeneficiary) => {
  let total = isDeleteBeneficiary ? 0 : Number(shares);
  if (checkContingent) {
    contingentBeneficiaries.map(currentBeneficiary => {
      if (currentBeneficiary.beneficiaryID !== beneficiaryID || isDeleteBeneficiary && contingentBeneficiaries.length === 1) {
        total = Number(total) + Number(currentBeneficiary.shares);
      }
      return true;
    });
  } else {
    primaryBeneficiaries.map(currentBeneficiary => {
      if (currentBeneficiary.beneficiaryID !== beneficiaryID || isDeleteBeneficiary && primaryBeneficiaries.length === 1) {
        total = Number(total) + Number(currentBeneficiary.shares);
      }
      return true;
    });
  }
  return Number(total) === 100;
};

/**
 * Validates the shares allocated to beneficiaries.
 * @param {object} beneficiaries - Object containing primary and contingent beneficiaries.
 * @param {boolean} isContingent - Flag indicating if contingent beneficiaries are being validated.
 * @param {number} shares - Total shares to be validated.
 * @param {string} beneficiaryID - ID of the beneficiary being modified.
 * @param {boolean} isDeleteBeneficiary - Flag indicating if a beneficiary is being deleted. 
 *                                        If true, the shares of the deleted beneficiary are not considered in the total calculation.
 * @returns {string|boolean} - Error message if shares are invalid, otherwise false.
 */
const validateShares = ({
  primaryBeneficiaries,
  contingentBeneficiaries
}, isContingent, shares, beneficiaryID, isDeleteBeneficiary = false) => {
  let sharesValid = true;
  if (isContingent) {
    sharesValid = checkShares(true, primaryBeneficiaries, contingentBeneficiaries, shares, beneficiaryID, isDeleteBeneficiary);
  } else {
    sharesValid = checkShares(false, primaryBeneficiaries, contingentBeneficiaries, shares, beneficiaryID, isDeleteBeneficiary);
  }
  const beneficiaryType = isContingent ? i18n.t(tokens.labels.beneficiaries.contingent) : i18n.t(tokens.labels.beneficiaries.primary);
  if (sharesValid) {
    return false;
  }
  return i18n.t(tokens.labels.beneficiaries.sharesMustEqualError, {
    beneficiaryType
  });
};
export default validateShares;